export default "__VITE_ASSET__YgVzLg0P__"